export const companyTypes = [
	{ label: "Kund", value: "Kund" },
	{ label: "Trial", value: "Trial" },
	{ label: "Demo", value: "Demo" },
	{ label: "Fintegrity", value: "Fintegrity" },
	{ label: "SEVR", value: "SEVR" },
] as const;
